// playerRepository.js (수정)

const getFourDigitYear = (year) => {
    // year가 null이거나 빈 문자열이거나 이미 4자리 이상인 경우 그대로 반환
    if (!year || typeof year !== 'string' || year.length >= 4) {
        return year;
    }

    const firstDigit = year.charAt(0);
    
    // 0, 1, 2, 3으로 시작하면 20을 붙임 (200x, 201x, 202x, 203x)
    if (['0', '1', '2', '3'].includes(firstDigit)) {
        return '20' + year;
    } 
    // 그 외 (4~9)로 시작하면 19를 붙임
    else {
        return '19' + year;
    }
};

// 💡 새로운 커스텀 스탯 점수 계산 함수
const getCustomStatScore = (player) => {
    if (!player || !player.originalStates) {
        return 0;
    }

    const states = player.originalStates;
    
    if (player.isPitcher) {
        // 투수: 변화(s2) + 구위(s3)
        return (states.s2 || 0) + (states.s3 || 0);
    } else {
        // 타자: 파워(s1) + 정확(s2)
        return (states.s1 || 0) + (states.s2 || 0);
    }
};


export const filterPlayers = (playersData, filters) => {
    if (!playersData || playersData.length === 0 || !filters) {
        return playersData;
    }

    const { 
        keyword = '', 
        teams = [], 
        positions = [], 
        types = [],
        sortKey = 'OVR 순'
    } = filters;

    const searchTokens = keyword.trim().toLowerCase().split(/\s+/).filter(token => token.length > 0);

    const filteredResults = playersData.filter(player => {
        // --- 필터링 로직 (유지) ---
        if (searchTokens.length > 0) {
            const allTokensMatch = searchTokens.every(token => {
                const name = player.playerName ? player.playerName.toLowerCase() : '';
                const desc = player.description ? player.description.toLowerCase() : '';
                const year = player.year ? String(player.year) : '';
                return name.includes(token) || desc.includes(token) || year.includes(token);
            });
            if (!allTokensMatch) {
                return false;
            }
        }
        
        if (teams.length > 0 && !teams.includes(player.team)) {
            return false;
        }

        if (positions.length > 0 && !positions.includes(player.position)) {
            return false;
        }

        if (types.length > 0 && !types.includes(player.type)) {
            return false;
        }

        return true;
    });

    // --- 3단계 정렬 로직 ---
    filteredResults.sort((a, b) => {
        
        const yearA = getFourDigitYear(a.year);
        const yearB = getFourDigitYear(b.year);
        
        const hasYearA = !!yearA && yearA.length === 4; 
        const hasYearB = !!yearB && yearB.length === 4;
        
        let primaryComparison = 0;

        switch (sortKey) {
            case "OVR 순":
                primaryComparison = b.originalOvr - a.originalOvr;
                break;
                
            case "세트덱 스코어 순":
                primaryComparison = b.setDeckScore - a.setDeckScore;
                break;
                
            // 💡 새 정렬 기준 추가
            case "파워+정확/변화+구위 순":
                const scoreA = getCustomStatScore(a);
                const scoreB = getCustomStatScore(b);
                primaryComparison = scoreB - scoreA; // 내림차순
                break;
                
            case "연도 순 - 오름차순":
                if (!hasYearA && hasYearB) primaryComparison = 1;
                else if (hasYearA && !hasYearB) primaryComparison = -1;
                else if (!hasYearA && !hasYearB) primaryComparison = 0;
                else {
                    primaryComparison = yearA.localeCompare(yearB); 
                }
                break;
                
            case "연도 순 - 내림차순":
                if (!hasYearA && hasYearB) primaryComparison = 1;
                else if (hasYearA && !hasYearB) primaryComparison = -1;
                else if (!hasYearA && !hasYearB) primaryComparison = 0;
                else {
                    primaryComparison = yearB.localeCompare(yearA); 
                }
                break;
                
            default:
                primaryComparison = b.originalOvr - a.originalOvr;
                break;
        }

        // 2차 정렬: OVR 순 (내림차순)
        if (primaryComparison === 0) {
            let secondaryComparison = b.originalOvr - a.originalOvr;
            
            // 3차 정렬: 이름 순 (가나다 순)
            if (secondaryComparison === 0) {
                const nameA = a.playerName || '';
                const nameB = b.playerName || '';
                
                return nameA.localeCompare(nameB, 'ko', { sensitivity: 'base' });
            }
            
            return secondaryComparison;
        }

        return primaryComparison;
    });

    return filteredResults;
};